$(document).ready(function(){
    $('.menu__button').click(function() {
        $('.menu').toggleClass('active');
        $('.menu__burger').toggleClass('active');
        $('.menu__button').toggleClass('active');
        if (document.querySelector('.menu.active')) {
            $('.menu__body').css({
                height: $('.menu_opened').outerHeight()
            })
        } else {
            $('.menu__body').css({
                height: ''
            })
        }
    })
})

$(document).ready(function(){
    $('.menu_bg').click(function() {
        $('.menu').toggleClass('active');
        $('.menu__burger').toggleClass('active');
        $('.menu__button').toggleClass('active');
        $('.menu__body').css({
            height: ''
        })
    })
})

document.addEventListener("DOMContentLoaded", e => {
    if (document.querySelector(".footer")) {
        window.addEventListener('scroll', e => {
            stopHeader()
        })
        stopHeader()
        
        function stopHeader() {
            let  scrolledHeight = document.body.clientHeight - 80
            let  scrolledHeightLarge = document.body.clientHeight - 100
            const headerItem = document.querySelector("#sidebar")
            if (window.pageYOffset >= scrolledHeightLarge - window.innerHeight) {
                if (document.documentElement.clientWidth <= 1400) {
                    headerItem.classList.add("stopped_large")
                } else {
                    headerItem.classList.add("stopped")
                }
            } else {
                headerItem.classList.remove("stopped_large")
                headerItem.classList.remove("stopped")
            }
        }
    }
})

